import styled from "styled-components";

interface inputTextStyleProps {
  showTiemer?: boolean;
  $paddingRight?: string;
  $disabledBorder?: boolean;
}

export const InputTextBox = styled.div<inputTextStyleProps>`
  position: relative;
  width: 100%;

  input  {
    width: 100%;
    padding-right: 60px;
  }
  
  input[type="text"]:disabled {
    border: ${(props) => props.$disabledBorder === true ? "1px solid #FE570B" : "1px solid #0000001f;"};
    background: ${(props) => props.theme.colors.white100};
  }

  &:has(input:focus) {
    input {
      border-color: ${(props) => props.theme.colors.primary100};
    }
  }
`;

export const Timer = styled.span `
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary100};
`;